export enum EnumClientTypes {
  FINAL_CLIENT = 6,
  EXTENDED_CLIENT = 12,
  DISTRIBUTOR = 3,
  COMMERCIAL = 8,
  WHOLESALER = 1,
  SHIPPER = 4
}
